import React, { ReactNode, useState } from "react"
import {
  Home,
  LayoutGrid,
  Shield,
  Gift,
  Mail,
  Umbrella,
  HandCoins,
  Puzzle,
  PiggyBank,
  Workflow,
  Settings,
  Users,
  Building2,
  Trophy,
  FileText,
  HeartPulse,
  X,
  Menu
} from "lucide-react"
import { Input } from "@/components/ui/input"

export default function FullPageWidget({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false)

  return (
    <div className="min-h-screen bg-gray-50 flex relative">
      {/* Fixed Sidebar (icons only) */}
      <aside className="fixed left-4 top-4 bottom-4 w-20 bg-[#35678a] rounded-[40px] shadow-xl flex flex-col items-center py-6 gap-6 z-50">
        <button onClick={() => setOpen(true)}>
          <Menu className="text-white" />
        </button>

        <SideIcon active icon={<Home />} />
        <SideIcon icon={<LayoutGrid />} />
        <SideIcon icon={<Shield />} />
        <SideIcon icon={<Gift />} />
        <SideIcon icon={<Mail />} />
        <SideIcon icon={<Umbrella />} />
        <SideIcon icon={<HandCoins />} />
        <SideIcon icon={<Puzzle />} />
        <SideIcon icon={<PiggyBank />} />
        <SideIcon icon={<Workflow />} />
        <SideIcon icon={<Settings />} />
        <SideIcon icon={<Users />} />
        <SideIcon icon={<Building2 />} />
        <SideIcon icon={<Trophy />} />
        <SideIcon icon={<FileText />} />
        <SideIcon icon={<HeartPulse />} />
      </aside>

      {/* Header */}
      <div className="flex-1 ml-28">
        <div className="flex items-center justify-between p-4 bg-white shadow-md">
          <h1 className="text-lg font-semibold">Dashboard</h1>
          <div className="w-64">
            <Input placeholder="Search..." />
          </div>
        </div>

        {/* Main Content */}
        {/* <div className="p-6">
          <div className="bg-white rounded-xl shadow p-6">
            <h2 className="text-lg font-semibold mb-2">Full Widget View</h2>
            <p className="text-sm text-slate-600">
              {children}
            </p>
          </div>
        </div> */}

      <div className="w-[90%]">
        {children}
        </div>
      </div>

      {/* Overlay */}
      {open && (
        <div className="fixed inset-0 bg-black/30 z-40" onClick={() => setOpen(false)} />
      )}

      {/* Drawer (full menu) */}
      <div
        className={`fixed top-4 bottom-4 left-[96px] w-[320px] bg-[#35678a] rounded-[40px] shadow-2xl z-50 transform transition-transform duration-300
        ${open ? "translate-x-0" : "-translate-x-[120%]"}`}
      >
        {/* Close */}
        <div className="p-4">
          <button
            onClick={() => setOpen(false)}
            className="bg-[#2f5f80] p-3 rounded-md text-white"
          >
            <X />
          </button>
        </div>

        {/* Menu Items */}
        <div className="px-6 py-4 space-y-6 text-white overflow-y-auto h-[calc(100%-80px)]">
          <NavItem icon={<Home />} label="Home" active />
          <NavItem icon={<LayoutGrid />} label="My Apps" />
          <NavItem icon={<Shield />} label="Background Verification" />
          <NavItem icon={<Gift />} label="Corporate Gifting" />
          <NavItem icon={<Mail />} label="Advance Salary" />
          <NavItem icon={<Umbrella />} label="Corporate Insurance" />
          <NavItem icon={<HandCoins />} label="Digital Lending" />
          <NavItem icon={<Puzzle />} label="Employee Engagement" />
          <NavItem icon={<PiggyBank />} label="Employee Financial Wellness" />
          <NavItem icon={<Workflow />} label="Flexible Benefits" />
          <NavItem icon={<Settings />} label="ITSM" />
          <NavItem icon={<Users />} label="Recruitment" />
          <NavItem icon={<Building2 />} label="Relocation" />
          <NavItem icon={<Trophy />} label="Rewards & Recognition" />
          <NavItem icon={<FileText />} label="Tax" />
          <NavItem icon={<HeartPulse />} label="Wellness" />
        </div>
      </div>
    </div>
  )
}

function SideIcon({ icon, active = false }: any) {
  return (
    <div
      className={`w-12 h-12 flex items-center justify-center rounded-xl cursor-pointer transition
      ${active ? "bg-lime-400 text-black" : "text-white/80 hover:text-white"}`}
    >
      {icon}
    </div>
  )
}

function NavItem({ icon, label, active = false }: any) {
  return (
    <div
      className={`flex items-center gap-4 text-lg cursor-pointer transition
        ${active ? "text-lime-300" : "text-white/90 hover:text-white"}`}
    >
      <div className="w-6 h-6">{icon}</div>
      <span>{label}</span>
    </div>
  )
}
